const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram: Density relationship map ─────────────────────────────
function DiagramDensityMap() {
  const W = 680, H = 220;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Density, Specific Weight &amp; Specific Gravity — Relationships</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrD" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" opacity="0.8"/>
          </marker>
        </defs>
        {/* Density */}
        <rect x="40" y="80" width="160" height="60" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="120" y="107" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Density  ρ</text>
        <text x="120" y="125" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">ρ = m / V  [kg/m³]</text>
        {/* Specific Weight */}
        <rect x="260" y="40" width="164" height="60" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="342" y="67" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Specific Weight  γ</text>
        <text x="342" y="85" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">γ = ρg  [N/m³]</text>
        {/* Specific Gravity */}
        <rect x="260" y="130" width="164" height="60" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="342" y="157" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Specific Gravity  SG</text>
        <text x="342" y="175" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">SG = ρ / ρ_water</text>
        {/* Specific Volume */}
        <rect x="490" y="80" width="160" height="60" rx="8" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="570" y="107" textAnchor="middle" fontFamily="Georgia,serif" fontSize="13" fontWeight="700" fill="#7B0D0D">Specific Volume  v</text>
        <text x="570" y="125" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">v = 1/ρ  [m³/kg]</text>
        {/* Arrows */}
        <line x1="200" y1="100" x2="258" y2="72" stroke="#c0392b" strokeWidth="1.2" markerEnd="url(#arrD)"/>
        <line x1="200" y1="110" x2="258" y2="158" stroke="#c0392b" strokeWidth="1.2" markerEnd="url(#arrD)"/>
        <line x1="424" y1="110" x2="488" y2="110" stroke="#c0392b" strokeWidth="1.2" markerEnd="url(#arrD)"/>
        {/* Reference note */}
        <text x="340" y="212" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888" fontStyle="italic">
          ρ_water = 1000 kg/m³ at 4°C   |   g = 9.81 m/s²
        </text>
      </svg>
      <div style={S.dCaption}>All specific properties derive from density. For liquids ρ is nearly constant; for gases ρ varies strongly with pressure and temperature.</div>
    </div>
  );
}

// ── Diagram: Couette velocity profile ─────────────────────────────
function DiagramCouette() {
  const W = 680, H = 240;
  const arrows = [
    { x1:116, x2:116,  op:0.25 },
    { x1:176, x2:204,  op:0.42 },
    { x1:236, x2:290,  op:0.58 },
    { x1:296, x2:376,  op:0.74 },
    { x1:356, x2:462,  op:0.90 },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Newtonian Shear Stress — Velocity Profile Between Parallel Plates</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrC" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#c0392b" opacity="0.8"/>
          </marker>
          <marker id="arrCB" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888"/>
          </marker>
          <marker id="arrCT" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#888"/>
          </marker>
        </defs>
        {/* Fixed bottom plate */}
        <rect x="60" y="185" width="420" height="16" rx="3" fill="#b0b0b0"/>
        <text x="500" y="196" fontFamily="Georgia,serif" fontSize="12" fill="#555">Fixed plate  (u = 0)</text>
        {/* Moving top plate */}
        <rect x="60" y="44" width="420" height="16" rx="3" fill="#c0392b" opacity="0.85"/>
        <text x="500" y="55" fontFamily="Georgia,serif" fontSize="12" fill="#7B0D0D" fontWeight="700">Moving plate  u = U</text>
        {/* Velocity arrows */}
        {arrows.map(({x1, x2, op}, i) => (
          <line key={i} x1={x1} y1="180" x2={x2} y2="64"
            stroke="#c0392b" strokeWidth={1 + i*0.25} opacity={op} markerEnd="url(#arrC)"/>
        ))}
        {/* Linear profile dashed */}
        <line x1="116" y1="180" x2="480" y2="60" stroke="#7B0D0D" strokeWidth="1" strokeDasharray="5 3"/>
        {/* Gap annotation */}
        <line x1="50" y1="60" x2="50" y2="185" stroke="#888" strokeWidth="1" markerEnd="url(#arrCB)" markerStart="url(#arrCT)"/>
        <text x="39" y="128" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">h</text>
        {/* Formula box */}
        <rect x="492" y="90" width="176" height="74" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="580" y="115" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">τ = μ (du/dy)</text>
        <text x="580" y="135" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#555">du/dy = U / h</text>
        <text x="580" y="154" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#777">(linear Couette flow)</text>
        {/* Bottom note */}
        <text x="270" y="222" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#888" fontStyle="italic">
          τ [Pa]   μ = dynamic viscosity [Pa·s]   du/dy = velocity gradient [1/s]
        </text>
      </svg>
      <div style={S.dCaption}>For a Newtonian fluid, shear stress is linearly proportional to the velocity gradient. The slope μ is the dynamic viscosity.</div>
    </div>
  );
}

// ── Diagram: Non-Newtonian shear stress vs shear rate ─────────────
function DiagramNonNewtonian() {
  const W = 680, H = 270;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Shear Stress vs Shear Rate — Fluid Behaviour Models</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrN" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#888"/>
          </marker>
        </defs>
        {/* Axes */}
        <line x1="70" y1="225" x2="545" y2="225" stroke="#888" strokeWidth="1.2" markerEnd="url(#arrN)"/>
        <line x1="70" y1="225" x2="70" y2="20" stroke="#888" strokeWidth="1.2" markerEnd="url(#arrN)"/>
        <text x="556" y="229" fontFamily="Georgia,serif" fontSize="12" fill="#555">du/dy</text>
        <text x="56" y="24" fontFamily="Georgia,serif" fontSize="12" fill="#555">τ</text>
        {/* Grid */}
        <line x1="70" y1="125" x2="540" y2="125" stroke="#eee" strokeWidth="0.8"/>
        <line x1="70" y1="175" x2="540" y2="175" stroke="#eee" strokeWidth="0.8"/>
        <line x1="200" y1="20" x2="200" y2="225" stroke="#eee" strokeWidth="0.8"/>
        <line x1="350" y1="20" x2="350" y2="225" stroke="#eee" strokeWidth="0.8"/>
        {/* Newtonian — straight */}
        <path d="M70 225 L 485 42" stroke="#c0392b" strokeWidth="2.2" fill="none"/>
        <text x="490" y="42" fontFamily="Georgia,serif" fontSize="12" fill="#c0392b" fontWeight="700">Newtonian</text>
        {/* Pseudo-plastic n&lt;1 — concave */}
        <path d="M70 225 C 130 168 235 98 485 60" stroke="#2980b9" strokeWidth="2.2" fill="none"/>
        <text x="490" y="63" fontFamily="Georgia,serif" fontSize="12" fill="#2980b9" fontWeight="700">Pseudo-plastic (n{'<'}1)</text>
        {/* Dilatant n&gt;1 — convex */}
        <path d="M70 225 C 215 215 335 160 485 24" stroke="#27ae60" strokeWidth="2.2" fill="none"/>
        <text x="490" y="27" fontFamily="Georgia,serif" fontSize="12" fill="#27ae60" fontWeight="700">Dilatant (n{'>'}1)</text>
        {/* Bingham plastic — offset linear */}
        <line x1="70" y1="225" x2="70" y2="170" stroke="#8e44ad" strokeWidth="2.2"/>
        <path d="M70 170 L 485 58" stroke="#8e44ad" strokeWidth="2.2" fill="none" strokeDasharray="7 3"/>
        <text x="490" y="61" fontFamily="Georgia,serif" fontSize="12" fill="#8e44ad" fontWeight="700">Bingham plastic</text>
        {/* Yield stress annotation */}
        <line x1="30" y1="170" x2="68" y2="170" stroke="#8e44ad" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="26" y="174" textAnchor="end" fontFamily="Courier New,monospace" fontSize="10" fill="#8e44ad">τ_y</text>
      </svg>
      <div style={S.dCaption}>
        Newtonian: straight line through origin. Pseudo-plastic (shear-thinning): viscosity falls with rate (e.g. blood, paint).
        Dilatant (shear-thickening): viscosity rises (e.g. cornstarch). Bingham plastic: requires yield stress τ_y before flowing (e.g. toothpaste, drilling mud).
      </div>
    </div>
  );
}

// ── Diagram: Capillary rise ────────────────────────────────────────
function DiagramCapillary() {
  const W = 680, H = 235;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Capillary Rise &amp; Contact Angle</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{width:'100%',display:'block'}}>
        <defs>
          <marker id="arrCap" markerWidth="7" markerHeight="7" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0, 6 3.5, 0 7" fill="#555"/>
          </marker>
          <marker id="arrCapR" markerWidth="7" markerHeight="7" refX="1" refY="3.5" orient="auto">
            <polygon points="6 0, 0 3.5, 6 7" fill="#555"/>
          </marker>
        </defs>
        {/* === Wetting (left) === */}
        <rect x="100" y="30" width="12" height="170" rx="4" fill="#aac8e8" opacity="0.7"/>
        <rect x="180" y="30" width="12" height="170" rx="4" fill="#aac8e8" opacity="0.7"/>
        <rect x="50" y="160" width="205" height="40" rx="4" fill="#aac8e8" opacity="0.4"/>
        <rect x="112" y="90" width="68" height="70" fill="#aac8e8" opacity="0.75"/>
        <path d="M112 90 Q146 76 180 90" stroke="#2980b9" strokeWidth="1.5" fill="#aac8e8" opacity="0.75"/>
        {/* contact angle arc */}
        <path d="M112 90 Q118 104 112 114" fill="none" stroke="#c0392b" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="84" y="108" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b">θ &lt; 90°</text>
        {/* rise annotation */}
        <line x1="88" y1="160" x2="88" y2="90" stroke="#555" strokeWidth="1" markerEnd="url(#arrCap)" markerStart="url(#arrCapR)"/>
        <text x="76" y="130" textAnchor="end" fontFamily="Courier New,monospace" fontSize="11" fill="#333">h</text>
        <text x="146" y="216" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#2980b9" fontWeight="700">Wetting fluid</text>
        <text x="146" y="230" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">(capillary rise)</text>

        {/* === Non-wetting (right) === */}
        <rect x="390" y="30" width="12" height="170" rx="4" fill="#aac8e8" opacity="0.7"/>
        <rect x="470" y="30" width="12" height="170" rx="4" fill="#aac8e8" opacity="0.7"/>
        <rect x="340" y="130" width="205" height="40" rx="4" fill="#b0b0c0" opacity="0.55"/>
        <rect x="402" y="150" width="68" height="20" fill="#b0b0c0" opacity="0.8"/>
        <path d="M402 150 Q436 164 470 150" stroke="#555" strokeWidth="1.5" fill="#b0b0c0" opacity="0.8"/>
        <path d="M470 150 Q464 136 470 128" fill="none" stroke="#c0392b" strokeWidth="1" strokeDasharray="3 2"/>
        <text x="476" y="136" fontFamily="Georgia,serif" fontSize="11" fill="#c0392b">θ &gt; 90°</text>
        <line x1="374" y1="130" x2="374" y2="150" stroke="#555" strokeWidth="1" markerEnd="url(#arrCap)" markerStart="url(#arrCapR)"/>
        <text x="362" y="143" textAnchor="end" fontFamily="Courier New,monospace" fontSize="11" fill="#333">h</text>
        <text x="436" y="216" textAnchor="middle" fontFamily="Georgia,serif" fontSize="12" fill="#555" fontWeight="700">Non-wetting fluid</text>
        <text x="436" y="230" textAnchor="middle" fontFamily="Georgia,serif" fontSize="11" fill="#555">(capillary depression)</text>

        {/* Formula box */}
        <rect x="542" y="52" width="128" height="90" rx="6" fill="#FEF0F0" stroke="#c0392b" strokeWidth="1"/>
        <text x="606" y="75" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="12" fontWeight="700" fill="#7B0D0D">h = 4σ cosθ</text>
        <text x="606" y="93" textAnchor="middle" fontFamily="Courier New,monospace" fontSize="11" fill="#7B0D0D">       ρ g D</text>
        <line x1="562" y1="100" x2="650" y2="100" stroke="#c0392b" strokeWidth="0.5"/>
        <text x="606" y="116" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#888">σ = surface tension</text>
        <text x="606" y="130" textAnchor="middle" fontFamily="Georgia,serif" fontSize="10" fill="#888">D = tube diameter</text>
      </svg>
      <div style={S.dCaption}>Left: wetting fluid (θ &lt; 90°, e.g. water on glass) — concave meniscus, capillary rise. Right: non-wetting (θ &gt; 90°, e.g. mercury on glass) — convex meniscus, capillary depression.</div>
    </div>
  );
}

// ── Main export ───────────────────────────────────────────────────
export default function FluidProperties() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Fluid Properties</h1>
      <p style={S.p}>
        A fluid is any substance that continuously deforms under an applied shear stress. Understanding fluid
        properties is the foundation of fluid mechanics — they govern how fluids store energy, resist flow,
        transmit pressure, and interact with surfaces.
      </p>

      <InfoBox title="CORE PROPERTY OVERVIEW" items={[
        "Density (ρ) — mass per unit volume; determines inertial and gravitational behaviour",
        "Viscosity (μ, ν) — resistance to shear deformation; governs flow resistance and boundary layers",
        "Surface tension (σ) — cohesive force at a free surface; drives capillarity and droplet formation",
        "Bulk modulus (K) — resistance to compression; determines speed of sound and wave propagation",
        "Vapor pressure (p_v) — saturation pressure at a given temperature; sets the cavitation threshold",
      ]}/>

      {/* ── Density ── */}
      <h2 style={S.h2}>Density &amp; Specific Properties</h2>
      <p style={S.p}>
        Density is the most fundamental fluid property and appears in virtually every governing equation.
        Specific gravity and specific weight are derived quantities that normalise density against reference
        values for convenient comparison.
      </p>
      <DiagramDensityMap/>
      <Table2 rows={[
        ["Density ρ",
`ρ = m / V  [kg/m³]
Water ≈ 998 kg/m³ (20°C),  Air ≈ 1.20 kg/m³ (20°C, 1 atm)
For ideal gases:  ρ = P / (R_specific · T)`],
        ["Specific weight γ",
`γ = ρ g  [N/m³]
Water: γ ≈ 9790 N/m³;  used in hydrostatic pressure: P = γ h`],
        ["Specific gravity SG",
`SG = ρ_fluid / ρ_water  (dimensionless)
Mercury SG ≈ 13.6;  seawater SG ≈ 1.025;  oil SG ≈ 0.85–0.95`],
        ["Specific volume v",
`v = 1 / ρ = V / m  [m³/kg]
Reciprocal of density; commonly used in thermodynamics`],
      ]}/>

      {/* ── Viscosity ── */}
      <h2 style={S.h2}>Viscosity</h2>
      <p style={S.p}>
        Viscosity quantifies a fluid's internal resistance to shear deformation. It is the single most
        important property governing whether flow is laminar or turbulent, how much pumping power is
        required, and the thickness of boundary layers on surfaces.
      </p>
      <DiagramCouette/>
      <Table2 rows={[
        ["Dynamic viscosity μ",
`τ = μ (du/dy)  [Pa·s  or  N·s/m²]
Water (20°C): μ ≈ 1.002 × 10⁻³ Pa·s
Air (20°C):   μ ≈ 1.81  × 10⁻⁵ Pa·s
Honey: μ ≈ 2–10 Pa·s (highly temperature-dependent)`],
        ["Kinematic viscosity ν",
`ν = μ / ρ  [m²/s]
Normalises for density; appears in the Reynolds number
Water (20°C): ν ≈ 1.004 × 10⁻⁶ m²/s
Air (20°C):   ν ≈ 1.51  × 10⁻⁵ m²/s`],
        ["Reynolds number Re",
`Re = ρVL / μ = VL / ν  (dimensionless)
Re < 2300 → laminar pipe flow
Re > 4000 → turbulent pipe flow`],
        ["Effect of temperature",
`Liquids: μ decreases with increasing T (weaker intermolecular bonds)
Gases:   μ increases with increasing T (more molecular collisions)
Sutherland's Law for gases: μ ∝ T^(3/2) / (T + S)`],
        ["No-slip condition",
`At a solid boundary, fluid velocity equals wall velocity
Fundamental boundary condition for viscous flow; arises from μ > 0`],
      ]}/>

      {/* ── Non-Newtonian ── */}
      <h2 style={S.h2}>Non-Newtonian Fluids</h2>
      <p style={S.p}>
        Many real fluids do not obey Newton's linear viscosity law. The relationship between shear stress
        and shear rate can be nonlinear, time-dependent, or involve a yield stress below which the material
        behaves as a solid.
      </p>
      <DiagramNonNewtonian/>
      <Table2 rows={[
        ["Power-law model",
`τ = K (du/dy)^n     (Ostwald–de Waele model)
K = consistency index [Pa·sⁿ],  n = flow behaviour index
n = 1 → Newtonian;  n < 1 → pseudo-plastic;  n > 1 → dilatant`],
        ["Bingham plastic",
`τ = τ_y + μ_p (du/dy)   when τ > τ_y,  else  du/dy = 0
τ_y = yield stress;  μ_p = plastic viscosity
Examples: toothpaste, mayonnaise, drilling mud, fresh concrete`],
        ["Thixotropic fluids",
`Apparent viscosity decreases over time at constant shear rate
Structure breaks down with prolonged shearing (e.g. gels, certain paints)
Opposite: rheopectic — viscosity increases with time under shear`],
        ["Viscoelastic fluids",
`Exhibit both viscous and elastic behaviour under deformation
Characterised by relaxation time λ; stress partly recovers on removal of strain
Examples: polymer melts, biological fluids, silicone putty`],
      ]}/>

      {/* ── Surface Tension ── */}
      <h2 style={S.h2}>Surface Tension &amp; Capillarity</h2>
      <p style={S.p}>
        At a liquid–gas interface, cohesive forces between liquid molecules create a surface under tension.
        This property becomes dominant at small length scales and is responsible for capillary rise, droplet
        formation, and the ability of insects to walk on water.
      </p>
      <DiagramCapillary/>
      <Table2 rows={[
        ["Surface tension σ",
`σ = F / L  [N/m]  — force per unit length along the interface
Water (20°C): σ ≈ 0.073 N/m;  Mercury: σ ≈ 0.484 N/m
Decreases with temperature; can be reduced by surfactants`],
        ["Pressure jump (Young–Laplace)",
`ΔP = σ (1/R₁ + 1/R₂)
For a spherical bubble:  ΔP = 4σ/R  (two surfaces)
For a spherical droplet: ΔP = 2σ/R  (one surface)`],
        ["Contact angle θ",
`Angle between liquid surface and solid at the contact line
θ < 90° → wetting (hydrophilic surface)
θ > 90° → non-wetting (hydrophobic surface)
θ ≈ 0°  → complete wetting (spreading)`],
        ["Capillary rise",
`h = 4σ cosθ / (ρ g D)
D = tube diameter [m]
Water in glass (D = 1 mm): h ≈ 30 mm rise
Mercury in glass: h is negative (depression)`],
        ["Weber number We",
`We = ρ V² L / σ  (dimensionless)
We << 1 → surface tension dominates (droplets, thin films)
We >> 1 → inertia dominates (jets, sprays)`],
      ]}/>

      {/* ── Compressibility ── */}
      <h2 style={S.h2}>Compressibility &amp; Bulk Modulus</h2>
      <p style={S.p}>
        Compressibility describes how much a fluid's volume changes under applied pressure. Liquids are nearly
        incompressible; gases are highly compressible. The bulk modulus governs the speed of pressure waves
        (sound) through a fluid.
      </p>
      <Table2 rows={[
        ["Bulk modulus K",
`K = −V (dP/dV) = ρ (dP/dρ)  [Pa]
Water: K ≈ 2.15 × 10⁹ Pa  (nearly incompressible)
Air (isothermal): K = P ≈ 10⁵ Pa  (highly compressible)
Higher K → stiffer fluid, harder to compress`],
        ["Compressibility β",
`β = 1 / K = −(1/V)(dV/dP)  [Pa⁻¹]
Small β for liquids; large β for gases
At high pressures, liquid β decreases further`],
        ["Speed of sound c",
`c = √(K / ρ) = √(dP/dρ)  [m/s]
Water (20°C): c ≈ 1482 m/s
Air   (20°C): c ≈  343 m/s
For ideal gas: c = √(γRT)  where γ = c_p / c_v`],
        ["Mach number Ma",
`Ma = V / c  (dimensionless)
Ma < 1 → subsonic;  Ma = 1 → sonic;  Ma > 1 → supersonic
Incompressible assumption valid when Ma < 0.3`],
        ["Ideal gas law",
`PV = nRT  →  P = ρ R_specific T
R (air) = 287 J/(kg·K),  R (water vapor) = 462 J/(kg·K)
ρ changes significantly with T and P for gases`],
      ]}/>

      {/* ── Vapor Pressure ── */}
      <h2 style={S.h2}>Vapor Pressure &amp; Cavitation</h2>
      <p style={S.p}>
        Vapor pressure is the pressure at which a liquid spontaneously vaporises at a given temperature.
        When local pressure drops below the vapor pressure in a flowing liquid, vapor bubbles form — a
        phenomenon called cavitation. The violent collapse of these bubbles causes damage to pumps,
        propellers, and turbines.
      </p>
      <Table2 rows={[
        ["Vapor pressure p_v",
`Increases strongly with temperature (Antoine equation)
Water: p_v ≈ 2338 Pa at 20°C;  p_v = 101 325 Pa at 100°C (boiling)
Fluids with high p_v are more prone to cavitation`],
        ["Cavitation",
`Occurs when local static pressure P < p_v
Vapor bubbles form, then collapse violently as pressure recovers
Causes pitting, erosion, noise, and efficiency loss in turbomachinery`],
        ["Cavitation number σ",
`σ = (P_ref − p_v) / (½ρV²)  (dimensionless)
Low σ → high cavitation risk
Critical σ below which cavitation begins depends on geometry`],
        ["NPSH (pumps)",
`NPSH = (P_s / ρg + V_s² / 2g) − p_v / ρg
NPSH_available must exceed NPSH_required to prevent cavitation
Critical design parameter for pump selection and installation height`],
      ]}/>

      {/* ── Summary ── */}
      <h2 style={S.h2}>Key Formulae Summary</h2>
      <InfoBox title="FLUID PROPERTIES — QUICK REFERENCE" items={[
        "Density:                 ρ = m/V  [kg/m³];  for ideal gas: ρ = P / (R_specific · T)",
        "Specific weight:         γ = ρg  [N/m³]",
        "Dynamic viscosity:       τ = μ (du/dy)  [Pa·s]",
        "Kinematic viscosity:     ν = μ / ρ  [m²/s]",
        "Reynolds number:         Re = ρVL / μ = VL / ν",
        "Power-law fluid:         τ = K (du/dy)^n",
        "Young–Laplace:           ΔP = 2σ/R (droplet),  4σ/R (bubble)",
        "Capillary rise:          h = 4σ cosθ / (ρgD)",
        "Bulk modulus:            K = ρ (dP/dρ)  [Pa]",
        "Speed of sound:          c = √(K/ρ);  for ideal gas: c = √(γRT)",
        "Cavitation number:       σ = (P_ref − p_v) / (½ρV²)",
      ]}/>
    </div>
  );
}